import { FC } from 'react';
import styled from 'styled-components';
import { body2 } from 'ui/theme';
import { RootProps } from '../types';

const Table = styled.div`
  ${body2}
  background: white;
  display: flex;
  flex-direction: column;
`;

export const Root: FC<React.PropsWithChildren<RootProps>> = ({ children }) => {
  return <Table data-test="nested-table-root">{children}</Table>;
};
